import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { ApiService, CoreUiPartialState, getArbCentralNavSecurity } from '@pos-app/core-ui';
import { ArbCentralNavSecurity, KEYS, USER_ROLE } from '@pos-app/data';
import { OOESessionService } from 'libs/core-ui/src/lib/services/ooe-session.service';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { OrdersPartialState } from '../../../orders/+state/orders.reducer';
import { CreateOrder } from '../../../orders/+state/orders.actions';
import { IOOEUserState } from '../../../epc/models/userState.model';

@Component({
  selector: 'app-help-you-sell',
  styleUrls: ['./help-you-sell.component.scss'],
  templateUrl: './help-you-sell.component.html',
})
export class HelpYouSellComponent implements OnInit {
  @ViewChild('selectVehicleContent') selectVehicleContent: TemplateRef<any>;

  myHelpComponents: any;
  helpMessage: string;
  isHovered: boolean = false;
  userProfile: any;
  private unSubscribe$ = new Subject<void>();
  arbCentralSecurityFunctions$: Observable<ArbCentralNavSecurity>;

  // Getter for OOE User State
  public get ooeUserState(): IOOEUserState {
    return this.ooeSessionService.getOOEUserState();
  }

  constructor(
    private router: Router,
    private apiService: ApiService,
    private ooeSessionService: OOESessionService,
    private toastr: ToastrService,
    private store: Store<OrdersPartialState>,
    private coreUiStore: Store<CoreUiPartialState>
  ) {}

  ngOnInit() {
    //get ARBCentralSecurity
    this.arbCentralSecurityFunctions$ = this.coreUiStore.select(getArbCentralNavSecurity);
  }

  // Navigate to a specific URL
  navigateTo(url: string): void {
    this.router.navigateByUrl(url);
  }

  // Scroll the help component list to the right
  scrollRighta(): void {
    this.scrollHelpComponentList(500);
  }

  // Scroll the help component list to the left
  scrollLefta(): void {
    this.scrollHelpComponentList(-500);
  }

  // Helper method to scroll the help component list
  private scrollHelpComponentList(offset: number): void {
    const element = document.querySelector('.my-help-component-lista') as HTMLElement;
    if (element) {
      element.scrollLeft += offset;
    }
  }

  // Start a new quote process
  startNewQuote(): void {
    if (this.ooeUserState?.genericQuotesOnlyTF) {
      this.apiService
        .fetchGenericCustomer()
        .pipe(takeUntil(this.unSubscribe$))
        .subscribe((genericCustomer) => {
          if (!this.ooeUserState?.defaultShipTo) {
            this.ooeSessionService.fetchUserState().subscribe((userState) => {
              this.ooeSessionService.setOOEUserState(userState);
              this.goToQuoteOrder(genericCustomer);
            });
          } else {
            this.goToQuoteOrder(genericCustomer);
          }
        });
    } else {
      this.router.navigateByUrl('/pos/orders-start?orderType=SQ');
    }
  }

  // Navigate to the quote order page
  private goToQuoteOrder(genericCustomer: any): void {
    const defaultShipTo = this.ooeUserState.defaultShipTo;
    if (!defaultShipTo) {
      this.toastr.error('Default Ship To is missing.');
      return;
    }

    this.apiService
      .fetchCustomerDetails({ customerNumber: defaultShipTo })
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((customerDetailsResponse) => {
        if (customerDetailsResponse?.ErrorFlag === '0') {
          const customerDetails = customerDetailsResponse.SearchResults[0];
          this.createQuoteOrder(genericCustomer, customerDetails);
        }
      });
  }

  // Check if the user is an external or programme user
  private isExternalOrProgrammeUser(): boolean {
    const userProfile = JSON.parse(localStorage.getItem(KEYS.jdeSession));
    return [USER_ROLE.external, USER_ROLE.programme].includes(userProfile?.Role);
  }

  // Create a new quote order
  private createQuoteOrder(genericCustomer: any, customerDetails: any): void {
    const data: any = {};

    if (this.isExternalOrProgrammeUser()) {
      // Populate data for external or programme users
      Object.assign(data, {
        customerNumber: genericCustomer?.customerNumber,
        customerName: genericCustomer?.customerName,
        shipToNumber: customerDetails?.customerNumber,
        shipToName: customerDetails?.customerName,
        reference: '',
        branch: customerDetails?.branchCode,
        orderType: 'SQ',
        currencyCode: customerDetails?.currencyCode,
        customerTaxRate: customerDetails?.customerTaxRate,
        customerPaymentTerms: customerDetails?.customerPaymentTerms,
        quickSaleYN: 'N',
      });
      this.store.dispatch(new CreateOrder({ data, toOrder: false, isNewOrder: true }));
    } else {
      // Populate data for other users
      Object.assign(data, {
        customerNumber: customerDetails?.customerNumber,
        shipToNumber: customerDetails?.defaultShipTo,
        shipToName: customerDetails?.defaultShipToName,
        reference: '',
        branch: customerDetails?.branchCode,
      });

      // Dispatch action for non-external users
      this.store.dispatch(new CreateOrder({ data, toOrder: false, isNewOrder: false }));
    }
  }
}
